<template lang="html">

  <div class="contenedor-error-cups">
  
    <!-- ESTE CUPS NO EXISTE -->
    <article class="error-cups" v-if="iderror == 0">
      <h4 v-if="counts <= 2">Ups! Parece que el CUPS es muy reciente o está mal introducido, por favor vuelve a intentarlo.</h4>
      <template v-if="counts > 2">
      <h4>Parece que tienes problemas con el CUPS, si quieres puedes ponerte en contacto con nosotros y resolver tus problemas</h4>
      <router-link class="btn -degree" :to="$t('enlaces.contacto')">Contacto</router-link>
      </template>
    </article>


    <template v-if="type == 'electric'">

    <!-- ESTE CUPS TIENE DEMASIADA POTENCIA CONTRATADA -->
    <article class="error-cups" v-if="iderror == 1">
        <h4>Este CUPS tiene demasiada potencia contratada, pero puedes escribirnos y contarnos cuales son tus necesidades.</h4>
        <router-link class="btn -degree" :to="$t('enlaces.tarifas_luz')+'/mas'">Saber más</router-link>
    </article>

    <!-- ESTE CUPS TIENE DEMASIADO CONSUMO AL AÑO -->
    <article class="error-cups" v-if="iderror == 2">
       <h4>Este CUPS tiene demasiado consumo anual, pero puedes escribirnos y contarnos cuales son tus necesidades.</h4>
       <router-link class="btn -degree" :to="$t('enlaces.contacto')">Saber más</router-link>
    </article>

    <!-- ESTE CUPS TIENE BONO SOCIAL -->
    <article class="error-cups" v-if="iderror == 3">
      <h4>Este CUPS tiene derecho al bono social.</h4>
    </article>


  </template>


  <template v-if="type == 'gas'">

     <!-- ESTE CUPS TIENE DEMASIADA POTENCIA CONTRATADA -->
     <article class="error-cups" v-if="iderror == 1">
      <h4>Este CUPS tiene un consumo muy elevado y no podemos continuar, si necesitas ayuda escribenos</h4>
      <router-link class="btn -degree" :to="$t('enlaces.contacto')">Saber más</router-link>
  </article>


  </template>




    <!-- YA CLIENTE -->
    <article class="error-cups" v-if="iderror == 10">
      <h4>Este CUPS ya tiene contrato con Iner. </h4>
    </article>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'mensajes-errores-cups',
    props : ['iderror','counts','type']
}
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/parts/mensaje-error-cups.vue